import { render, staticRenderFns } from "./syncProduct.vue?vue&type=template&id=115d4a45&scoped=true"
import script from "./syncProduct.vue?vue&type=script&lang=js"
export * from "./syncProduct.vue?vue&type=script&lang=js"
import style0 from "./syncProduct.vue?vue&type=style&index=0&id=115d4a45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115d4a45",
  null
  
)

export default component.exports